import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Arriving from the List overview "Create new campaign" hover action (`?createCampaign=true`):
 * fire `onCreate` once the page is `ready` (the list has loaded), then strip the param from the
 * URL so a refetch / re-render doesn't re-trigger it.
 */
export const useAutoCreateCampaignParam = (ready: boolean, onCreate: () => void): void => {
	const location = useLocation();
	const navigate = useNavigate();
	const triggeredRef = useRef(false);

	useEffect(() => {
		if (!ready || triggeredRef.current) {
			return;
		}

		const params = new URLSearchParams(location.search);

		if (params.get("createCampaign") !== "true") {
			return;
		}

		triggeredRef.current = true;
		onCreate();
		params.delete("createCampaign");
		navigate({ search: params.toString() }, { replace: true });
	}, [ready, location.search, navigate, onCreate]);
};
